import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../../services/data.service';
import { Observable, catchError } from 'rxjs';
import { NotificationPreferences } from 'src/app/features/notifications-preferences/notifications-preferences';

@Injectable({
  providedIn: 'root'
})


export class NotificationsPreferencesService extends DataService{
  private baseURI = this.apiUri + '/notificationspref/';

  constructor(http: HttpClient) {
    super(http);
  }

  saveNotifPref(notifPref:NotificationPreferences){
    return this.http.post(this.baseURI + 'save', notifPref,{responseType: 'text'}).pipe(catchError(this.handleError));
  }

  getNotifPref(orgId,busType,orgType,notifType): Observable<any>{
    return this.http.get(this.baseURI + 'preferences/' + orgId + '/orgId/' + busType + '/busType/'
                                + orgType + '/orgType/' + notifType + '/notifType');
  }

  getNotifPrefByBusinessTypeAndOrgId(businessType: string, organizationId: Number):Observable<any>{
    return this.http.get(this.baseURI + 'preferences/' + businessType + "/businesstype/" + organizationId + "/organizationId /");
  }

  // getNotifPrefByBusinessTypeAndNoficationType(businessType: string, notificationType: string):Observable<any>{
  //   return this.http.get(this.baseURI + 'preferences/' + businessType + "/businesstype/" + notificationType + "/notificationtype/");
  // }

}
